import { useEffect, useRef } from 'react';
import {
  isIOS,
  isAndroidDevice,
  getWinWidth
} from 'core_modules/bootstrap/browsers/browser-detection';

const useAccordionDrawerEvents = (parentSelector, callback, triggerSelector) => {
  const closeCtaSelector = `${parentSelector} button[class*="_backButton_"]`;
  const eventWrapSelector = `${parentSelector} ${
    triggerSelector ? triggerSelector : '.accordionEventWrap'
  }`;
  const registeredEle = useRef();

  const eventHandler = () => {
    setTimeout(() => {
      const closeCta = document.querySelector(closeCtaSelector);
      if (closeCta) {
        callback(true);
      } else {
        callback(false);
      }
    }, 200);
  };

  useEffect(() => {
    let targetEle = registeredEle.current;
    const winWidth = getWinWidth();
    if (winWidth < 768 && !targetEle) {
      setTimeout(() => {
        targetEle = document.querySelector(eventWrapSelector);
        registeredEle.current = targetEle;
        targetEle.addEventListener('click', eventHandler);
      }, isIOS() || isAndroidDevice() ? 2000 : 500);
    }

    return () => {
      const targetEle = registeredEle.current;
      if (targetEle) {
        targetEle.removeEventListener('click', eventHandler);
        registeredEle.current = null;
      }
    };
  }, []);

  return null;
};

export default useAccordionDrawerEvents;
